import React from 'react';
import { Link } from 'react-router-dom';

import HeaderContainer from 'user/common/Header';

let fbSalonId;
if (window.location.href.indexOf('state=') > 0) {
  [, fbSalonId] = window.location.href.split('state=');
  window.faceBookSalonId = fbSalonId;
}

const NotFoundComponent = (props) => {
  if (props.location.pathname.indexOf('state=') >= 0) {
    const salonId = props.location.pathname.split('state=')[1];
    props.history.push(`/salon/${salonId}/onlinebooking`);
    return null;
  }

  return (
    <div className="screen-wrap">
      <div className="header-bg" />
      <div className="content-wrap">
        <HeaderContainer title="Page Not Found" description="Sorry, we couldn't find that page" />
        <div className="content login auto-height">
          <div>You tried to get to</div>
          <br />
          <div>{props.location.pathname}</div>
          <br />
          <div>But we couldn&apos;t find that page</div>
          <br />
          <Link to="/login" href="/login" className="btn btn-violet-link">
            Back to Login
          </Link>
          <a className="btn btn-violet-link" href="https://getslick.com/" target="_blank" rel="noopener noreferrer">
            Slick Website
          </a>
          <Link to="/signup" href="/signup" className="btn btn-violet-link">
            Sign Up
          </Link>
        </div>
      </div>
      <footer className="footer" />
      <div className="footer-additional" />
    </div>
  );
};

export default NotFoundComponent;
